
import { get, post } from './request';
import request from '@/utils/request2'

export function getUserInfo(userId) {
  return get(`/user/${userId}`);
}

export function createUser(user) {
  return post('/user/create', user);
}

export function userLogin(data) {
    return post('/business/login', data);
}

// 上传文件
export function uploadFile(data) {
  return post('/system/upload', data);
}
// 验证是否为blob格式
export async function blobValidate(data) {
  try {
    const text = await data.text();
    JSON.parse(text);
    return false;
  } catch (error) {
    return true;
  }
}
export function uploadFile2(fd) {
  return request({
    url: '/system/businessgoods/uploadInboundExcel',
    method: 'post',
    headers:{
      "Content-Type": "application/x-www-form-urlencoded",
        "token": window.localStorage.getItem('token'),
        "storeId":localStorage.getItem('storeId'),
    },
    timeout: 600000,
    data: fd,
    responseType: 'blob',
  })
}

// 获取批量修改项
export function getGoodsTypeChangeList() {
  return get('/goods/GoodsTypeChangeList');
}

// 批量修改商品类别
export function getGoodsTypeChange(data) {
  return post('/goods/GoodsTypeChange', data);
}

//获取门店列表
export function getStoreList(data) {
    return post('/store/storeQuery', data);
}

//获取订单信息getGoodsList
export function getOrder(data) {
    return post('/order/orderQueryByDate', data);
}
//获取商品列表
export function getGoodsList(data) {
  return post('/store/storeGoodsQuery', data);
}
//获取商品详情
export function getGoodsDetail(data) {
  return post('/store/queryStoreGoodsDetail', data);
}
//修改商品信息
export function editGoodsInfo(data) {
  return post('/store/editStoreGoods', data);
}
//删除
export function deleteGoods(data) {
  return post('/store/deleteStoreGoods', data);
}

//获取商品类型列表
export function getGoodsTypeList(data) {
  return post('/goods/goodsTypeQuery', data);
}

//获取盘点单的列表
export function getCountGoodsList(data) {
  return post('/system/inventory/list', data);
}
//获取盘点单的详情
export function getCountGoodsDetail(data) {
  return get(`/system/inventory/${data}`);
}
//获取商品的列表（所有和分类）
export function getAllGoodsList(data) {
  return post('/store/storeGoodsQuery', data);
}
// 提交盘点单
export function submitCountGoods(data) {
  return post('/system/inventory', data);
}
//获取入库记录
export function getStorageRecord(data) {
  return get('/system/businessgoods/list', data);
}
//获取入库单详情
export function getStorageDetail(data) {
  return get(`/system/businessgoods/${data}`);
}
//添加入库
export function addStorage(data) {
  return post('/system/businessgoods', data);
}

//获取会员列表
export function getMemberList(data) {
  return get('/wxuser/queryStoreVipList', data);
}
//修改会员信息
export function editMemberInfo(data) {
  return post('/wxuser/setUserDesc', data);
}

//获取标签列表
export function getLabelList(data) {
  return get('/system/tag/list', data);
}
//添加标签
export function addLabel(data) {
  return post('/system/tag', data);
}
//修改标签
export function editLabel(data) {
  return post('/system/tag', data);
}
//删除标签
export function deleteLabel(data) {
  return get(`/system/relation/del/${data}`);
}

//获取黑名单列表
export function getBlackList(data) {
  return get('/storeSalesAnalysis/GetBlackList', data);
}
//添加黑名单
export function addBlack(data) {
  return get('/storeSalesAnalysis/AddBlackUser', data);
}
//删除黑名单
export function deleteBlack(data) {
  return get(`/storeSalesAnalysis/DeleteBlackUser`, data);
}

//获取进门记录
export function getEnterRecord(data) {
  return post('/store/storeEnterRecord', data);
}

//获取今日、昨日订单
export function getDayOrder(data) {
  return post('/store/turnoverQueryByDate', data);
}

//获取个人信息
export function getPersonInfo(data) {
  return post('/store/storeDetailQuery', data);
}

// 销量汇总
//获取商品销量
export function getGoodsSales(data) {
  return get('/store/turnTenQuery', data);
}

//获取单品销量
export function getSingleGoodsSales(data) {
  return get('/store/queryGoodsRankingsByDate', data);
}
//获取销量记录
export function getSalesRecord(data) {
  return get('/storeSalesAnalysis/Statistics', data);
}

//分时段销量
export function getSalesTime(data) {
  return get('/storeSalesAnalysis/classificationTime', data);
}
//分类统计销量
export function getSalesClassify(data) {
  return get('/storeSalesAnalysis/classificationStatistics', data);
}
//获取 促销活动列表
export function getSaleActivity(data) {
  return get('/Activity/list', data);
}
//获取已过期的促销活动列表
export function getOverdueSaleActivity(data) {
  return get('/Activity/JSlist', data);
}

//获取门店列表
export function getStore(data) {
  return post('/store/storeQuery', data);
}
//改变门店状态
export function changeStoreStatus(data) {
  return post('/business/updateCloudGuard', data);
}
//开门
export function openDoor(data) {
  return post('/business/openDoor', data);
}

// 获取收银机图片
export function getCashierImg(data) {
  return get('/store/getCashierImg', data);
}

// Activity: domain + "/Activity", // 活动
//   Activitylist: domain + "/Activity/list", // 活动
//   ActivityJSlist: domain + "/Activity/JSlist", // 活动
//   Activitydel: domain + "/Activity/del", // 活动


export function Activity(data) {
  return get('/Activity/'+ data);
}
export function Activity2(data) {
  return post('/Activity', data);
}
export function Activitylist(data) {
  return get('/Activity/list', data);

}

export function ActivityJSlist(data) {
  return get('/Activity/JSlist', data);


}

export function Activitydel(data) {
  return get('/Activity/del/'+ data);
}

// CameraDevice: "/devicelog/access/CameraDevice", // 查询门店监控数据
//   CameraUserDevice:"/devicelog/access", // 查询某用户全部进门记录
//   CameraDeviceList: "/devicelog/access/list", // 查询门禁进出日记列表
//   orderById: "/order", // 查询订单详情

export function CameraDevice(data) {
  return get('/devicelog/access/CameraDevice/'+data);
}
export function CameraUserDevice(data) {
  return get('/devicelog/access/'+ data);

}
export function CameraDeviceListreq(data) {
  return get('/devicelog/access/list', data);

}
export function orderById(data) {
  return get('/order/'+ data);

}




// WEBPACK FOOTER //
// ./src/api/api.js